var productionMode = false;
var environment = 'staging'
var serverUrl = 'https://mon.qtrust.id:40013';
var serviceName = 'dso-dashboard';
var secretToken = 'PpUw5ZibLVZFORV';
const gaId = 'G-Y6PBKZPFNJ';
const urlStart = 'https://ssdso-dash.qtrust.id';
export default {gaId, productionMode , environment , serverUrl , serviceName, secretToken,  urlStart};
